import React from 'react';
import styled from 'App/styled';
import { ActiveFilter, ListingFilter } from '@nykaa/listing-shared/type/filter';
import { changeFilterApiStatus } from '@nykaa/listing-shared/search/store/actions';
import { changeFilterApiStatus as changeCategFilterApiStatus } from '@nykaa/listing-shared/category/store/action';
import { trackFilter } from 'helpers/filters/tracking';
import { handleFilterAction } from 'helpers/filters';
import { titleId } from 'components/ListingPage/Scroll/constants';
import Tabs from './Tabs';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import { PRICE_RANGE_FILTER, RANGE_FILTER } from '@nykaa/price-filter-shared/constants';
import { FilterComponentProps, RangeAdditionalProps } from 'types/filter';


const FilterComponent = ({ filters = [], activeFilters, handleFilter, isApiFailed, handleResetApiStatus, isSearch }: FilterComponentProps) => {
  const searchListingPage = useSelector((state: State) => state.searchListingPage);
  const categoryListing = useSelector((state: State) => state.categoryListing);
  const searchItemsCount = searchListingPage.listingData?.totalFound || 0;
  const categItemsCount = categoryListing.listingData?.totalFound || 0;
  const searchIsClearAll = searchListingPage.isClearAll || searchListingPage.isEmptyRangeError;
  const categoryIsClearAll = categoryListing.isClearAll || categoryListing.isEmptyRangeError;
  return (
    <div key="filter-list">
      {filters?.map((filter, idx) => {
      const additionalProps: RangeAdditionalProps = {};
      const { key, type } = filter;
      if ((key === PRICE_RANGE_FILTER) && (type === RANGE_FILTER)) {
        additionalProps.isApiFailed = isApiFailed;
        additionalProps.handleResetApiStatus = handleResetApiStatus;
        additionalProps.itemsCount = (isSearch ? searchItemsCount : categItemsCount);
        additionalProps.isClearAll = (isSearch ? searchIsClearAll : categoryIsClearAll);
      };
      return (
        <Tabs
          key={filter.key + 'tabs'}
          filter={filter}
          isFirst = {idx === 0}
          isLast = {idx === filters?.length - 1}
          activeFilters={activeFilters}
          handleChange={handleFilter}
          {...additionalProps}
        />
      );
    })}
    </div>
);};

const FilterWrapper = styled.div`
  width: 270px;
  border: solid 1px white;
  background-color: #ffffff;
  border-radius: 4px;
  .sidebar__inner {
    border-radius: 4px;
    width: 270px;
    background-color: #ffffff;
    z-index: 3;
    box-shadow: 0 1px 3px rgba(226, 226, 226, 0.25), 0 1px 2px rgba(226, 226, 226, 0.5);
  }
`;

interface FilterProps {
  filters: ListingFilter[];
  pageName: string;
  pageTitle: string;
  activeFilters: { [key: string]: ActiveFilter | number | string };
  changeFilter: (e: ActiveFilter | number | string, isClickAll?: boolean) => void;
  isSearch?: boolean;
}

const Filters = ({ filters = [], activeFilters, changeFilter, pageName, pageTitle, isSearch = false }: FilterProps) => {
  const searchApiFailed = useSelector((state: State) => state.searchListingPage.listingData?.isApiFailed);
  const categoryApiFailed = useSelector((state: State) => state.categoryListing.listingData?.isApiFailed);
  const handleFilter = (filter: ActiveFilter) => {
    const newFilters = handleFilterAction(activeFilters, filter);
    changeFilter(newFilters);
    const titleTop = ((document.getElementById(titleId) as HTMLElement)?.offsetTop - 100) || 0;
    window.scrollTo({
      top: titleTop,
      left: 0,
      behavior: 'smooth',
    });
    trackFilter(newFilters, { pageType: pageName, pageTitle: pageTitle });
  };
  const isApiFailed = (isSearch ? searchApiFailed : categoryApiFailed );
  const resetApiFailStatus = (isSearch ? changeFilterApiStatus : changeCategFilterApiStatus);
  return (
    <FilterWrapper id="filters-strip">
      <div className="sidebar__inner">
        <FilterComponent
          filters={filters}
          activeFilters={activeFilters}
          handleFilter={handleFilter}
          isApiFailed={isApiFailed}
          handleResetApiStatus={resetApiFailStatus}
          isSearch={isSearch}
        />
      </div>
    </FilterWrapper>
  );
};

export default Filters;
